'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ModalConstants = undefined;

var _keymirror = require('keymirror');

var _keymirror2 = _interopRequireDefault(_keymirror);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ModalConstants = exports.ModalConstants = (0, _keymirror2.default)({
    MODAL_SHOW: null,
    MODAL_HIDE: null
});


//////////////////
// WEBPACK FOOTER
// ./src/redux/constants/modal.js
// module id = 1872
// module chunks = 0